export default __webpack_public_path__ + "static/media/successBG.6be25d75.png";